import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import ForMechanics from "./pages/ForMechanics";
import FixOrReplace from "./pages/FixOrReplace";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/for-mechanics" element={<ForMechanics />} />
                    <Route path="/fix-or-replace" element={<FixOrReplace />} />
                </Routes>
                <Footer />
                <Toaster
                    position="bottom-right"
                    richColors
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
